import { render } from "./EmployeeSideBar.vue?vue&type=template&id=bd47d656"
import script from "./EmployeeSideBar.vue?vue&type=script&lang=js"
export * from "./EmployeeSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__